import React from 'react';
import {observer} from 'mobx-react';

import {ACTION_TYPES} from "../../../core/consts";
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {Link} from "../../../core/components/link/link";
import {LinkProps} from "../../../core/components/link/link-composer";
import {APP} from "../../../core/app/consts";
import {PreviousMeetingsWidgetMatchRowCompetitor} from "./previous-meetings-widget.match-row.competitor";
import {
  PreviousMeetingsWidgetUsLayoutPartialGameViewModel
} from "../models/previous-meetings-widget.us-layout.partial-game.view-model";
import styles from "../styles/previous-meetings-widget.match-row.module.scss";
import classNames from "classnames";
import {PreviousMeetingsWidgetMatchRowBottom} from "./previous-meetings-widget.match-row-bottom";
import {PreviousMeetingsWidgetMatchRowDate} from "./previous-meetings-widget.match-row-date";

export class PreviousMeetingsWidgetRowComponentProps extends PreviousMeetingsWidgetProps {
  item: PreviousMeetingsWidgetUsLayoutPartialGameViewModel;
}

export const PreviousMeetingsWidgetMatchRow = observer(({
                                                          controller,
                                                          item
                                                        }: PreviousMeetingsWidgetRowComponentProps) => {
  const {state, device: {isSmallView}} = controller
  const {
    id,
    linkModel,
    isScheduled,
    domainModel,
    competition,
    statusGroup,
    sport,
    homeCompetitor,
    awayCompetitor,
    hasOdds
  } = item;
  const {currentLinkModel, showOdds, isUsH2hLayout} = state;
  const shouldRenderOdds = showOdds && hasOdds;
  const linkProps: LinkProps = {
    model: linkModel,
    className: classNames(styles.match_row, {
      [styles.scheduled_match_row]: isScheduled,
      [styles.small_view]: isSmallView,
      [styles.show_odds]: shouldRenderOdds,
      [styles.us_layout]: isUsH2hLayout
    }),
    routeProps: {
      dataSource: {
        game: {
          apiModel: domainModel.apiModel,
          homeCompetitor: domainModel.homeCompetitor,
          awayCompetitor: domainModel.awayCompetitor,
          sport: domainModel.sport,
          competition: domainModel.competition,
          startTime: domainModel.startTime,
        }
      }
    },
    onClick: () => onClick()
  }

  const onClick = () => {
    controller.action(ACTION_TYPES.matchDetailsClick, {
      gameId: id,
      competitionId: competition.id,
      status: statusGroup,
      source: APP.ANALYTICS.SOURCES[currentLinkModel.name],
      placement: APP.GOOGLE_ANALYTICS.SOURCES[currentLinkModel.name],
      currentLinkModelName: currentLinkModel.name,
      screenId: currentLinkModel.params.id,
      sportTypeId: sport.id
    });

    return true;
  }

  const dateProps = {
    className: classNames(styles.date),
    date: item.bottomText
  }

  return (
      <Link {...linkProps}>
        <PreviousMeetingsWidgetMatchRowCompetitor competitor={homeCompetitor} shouldRenderOdds={shouldRenderOdds}/>
        <div className={classNames(styles.secondary_text, styles.club)}>
          {item.topText}
        </div>
        <div className={classNames(styles.content_main_text, styles.score)}>
          {item.scoreTimeText}
        </div>
        <PreviousMeetingsWidgetMatchRowCompetitor competitor={awayCompetitor} isAway
                                                  shouldRenderOdds={shouldRenderOdds}/>
        <PreviousMeetingsWidgetMatchRowBottom controller={controller} item={item} shouldRenderOdds={shouldRenderOdds}/>
        <PreviousMeetingsWidgetMatchRowDate {...dateProps}/>
      </Link>
  )
});
